global.env = {

    //api_server_dev: 'https://localhost:7046',
    api_server_dev: 'http://127.0.0.1:8000'
  
  };